import BallotIcon from '@mui/icons-material/Ballot';
import { Button } from '@mui/material';
import { SahinDataTable } from 'common/components/DataTable/SahinDataTable';
import { EmptyState } from 'common/components/EmptyState';
import { useAppSelector } from 'common/context/hooks';
import { Nullable } from 'common/model/Nullable';
import { useCallback, useState } from 'react';
import { ContactForm } from '../Form/ContactForm';
import { contactListColumns } from './ContactList.types';
import { AdminTablePaths } from 'common/model/AdminTablePaths';

export const COMPONENT_TABLE_PATH = AdminTablePaths.CONTACT;

export const ContactList = () => {
  const contacts = useAppSelector((state) => state.common.contacts);
  const [selectedItem, setSelected] =
    useState<Nullable<Partial<Contact>>>(null);

  const onAdd = () => {
    setSelected({});
  };

  const onCloseModal = () => {
    setSelected(null);
  };

  const showContact = useCallback((params: any) => {
    const handleSelect = () => {
      setSelected(params.row as Contact);
    };

    return (
      <Button onClick={handleSelect}>
        <BallotIcon />
      </Button>
    );
  }, []);

  return (
    <>
      <ContactForm
        open={Boolean(selectedItem)}
        contact={selectedItem}
        handleClose={onCloseModal}
      />
      <SahinDataTable
        data={contacts}
        columns={contactListColumns}
        onAdd={onAdd}
        customActionComponent={showContact}
        customActionComponentTitle="Görüntüle"
        actionButtonColumnWidth={150}
        customEmptyMessage={
          <EmptyState
            title="Henüz Mesaj Yok"
            description="Müşterilerinizden henüz mesaj gelmemiş. Bu, hizmetinizin sorunsuz çalıştığını gösteriyor! 🎉"
            icon="✅"
            iconSize={55}
            tip="Müşterileriniz sorun yaşadığında veya önerileri olduğunda burada mesajlarını görebileceksiniz. Şu anda her şey yolunda görünüyor."
            tipTitle="🎯 Müşteri Memnuniyeti"
            variant="custom"
          />
        }
      />
    </>
  );
};
